	<template>
		<div class="no-permission" v-if="!$nikan.checkPermission(policyClaims)" startup>
			<div class="no-access alert alert-danger no-items">
				<img src="../../assets/logo-nikan-white.png" alt="Access Denied">
				<p>{{ $t('policy.access-denied') }}</p>
			</div>
		</div>
	</template>

<script>
	import $ from 'jquery'
	import _ from 'lodash'
	export default {
		props: {
			policyClaims: { type: [Array, String, Object, Function], default: () => [] }
		},
		mounted() {
			this.removeScroll()
		},
		methods: {
			removeScroll() {
				this.defer(() => {
					$('.no-permission').closest('.grid-stack-item-content').css('overflow-y', 'hidden')
				}, 100)
			}
		},
	}
</script>